import React, { useState, useContext, useRef, useEffect } from "react";
import { User, Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import homeImage from "../images/home.png";
import AuthContext from "../contexts/AuthContext/AuthContext";

import "./Navbar.css"; // Import the CSS for styling

const Navbar = () => {
  const { user, isSignedIn, isClinician, logout } = useContext(AuthContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  console.log("Navbar - user:", user, "isSignedIn:", isSignedIn);
  console.log("Navbar - username specifically:", user?.username);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleSignOut = () => {
    logout();
    setIsDropdownOpen(false);
    navigate("/signin");
  };

  const handleHomeClick = () => {
    navigate("/home");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="top-menu">
      <div className="menu-left">
        <button onClick={handleHomeClick} className="menu-button">
          <img src={homeImage} alt="Home" />
        </button>
      </div>
      <div className="menu-right">
        <nav className="navbar-role-links" aria-label="Primary">
          {isSignedIn &&
            (isClinician ? (
              <Link to="/provider/patients" className="navbar-role-link">
                Patients
              </Link>
            ) : (
              <>
                <Link to="/home" className="navbar-role-link">
                  Games
                </Link>
                <Link to="/stats" className="navbar-role-link">
                  My Stats
                </Link>
              </>
            ))}
          {/* Contact is public — visible signed in or out. */}
          <Link to="/contact" className="navbar-role-link">
            Contact
          </Link>
        </nav>
        {/* Ensure Auth component applies the new class */}
        {isSignedIn ? (
          <div className="navbar-dropdown" ref={dropdownRef}>
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              onTouchStart={() => {}}
              className="navbar-mobile-dropdown-toggle"
              aria-expanded={isDropdownOpen}
              aria-haspopup="true"
            >
              <User size={20} className="navbar-icon" />
              {/* Usernames are generated now, so greet people by name. */}
              <span>{user?.first_name || user?.username || "Account"}</span>
            </button>
            {isDropdownOpen && (
              <div className="navbar-mobile-dropdown-menu">
                <Link
                  to="/settings"
                  className="navbar-mobile-dropdown-item"
                  onClick={() => setIsDropdownOpen(false)}
                  aria-label="Settings"
                >
                  Settings
                </Link>
                {!isClinician && (
                  <Link
                    to="/settings/care-team"
                    className="navbar-mobile-dropdown-item"
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    My care team
                  </Link>
                )}
                <button
                  onClick={handleSignOut}
                  onTouchStart={() => {}}
                  className="navbar-mobile-dropdown-item"
                  aria-label="Sign out"
                >
                  Sign Out
                </button>
              </div>
            )}
          </div>
        ) : (
          <Link
            to="/signin"
            className="navbar-mobile-link navbar-signin"
            onClick={() => setIsMenuOpen(false)}
          >
            <User size={20} className="navbar-icon" />
            <span>Sign In</span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default Navbar;
